import React from "react";

const initialPageState = {
    header: "Welcome",
    actionItems: [],
};

const pageReducer = (state, action) => {
    return {
        ...state,
        header: action.header || initialPageState.header,
        actionItems: action.actionItems || initialPageState.actionItems,
    };
};

export const PageContext = React.createContext({
    state: initialPageState,
    dispatch: () => null
});

export const PageProvider = ({ children }) => {
    const [pageState, pageDispatch] = React.useReducer(pageReducer, initialPageState);

    return (
        <PageContext.Provider value={[pageState, pageDispatch]}>
            {children}
        </PageContext.Provider>
    );
};
